import script from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=81bded4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81bded4c"]])

export default __exports__